import React, { Component } from 'react';
import { Row, Button } from 'reactstrap';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import {
  MODERATE_GIF, SET_GIF_RANK, SET_GIF_AUTO_RELEASE_DATE,
  SET_GIF_TAGS, SET_GIF_DESIGNER_RANK,
} from '../../mutation/mutation';
import './gif.css';
import DatePicker from 'react-date-picker';

const styles = theme => ({
  root: {
    'width': 500,
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
});

class Gif extends Component {
  constructor(props) {
    super(props);
    let tags = props.gif.tags || [];
    tags = tags.map(tagId => props.tags.find(tag => tag._id === tagId));
    this.state = {
      date: props.gif.autoReleaseDate ? new Date(props.gif.autoReleaseDate) : new Date(),
      display: true,
      rank: +props.gif.rank || 0,
      designerRank: +props.gif.designerRank || 0,
      tags: tags,
    };
    this.editRank = this.editRank.bind(this);
    this.editDesignerRank = this.editDesignerRank.bind(this);
    this.editTags = this.editTags.bind(this);
    this.editAutoReleaseDate = this.editAutoReleaseDate.bind(this);
  }

  moderateGif(accept) {
    if (accept) {
      const confirm = window.confirm('⚠️ Make this gif public? It will be available for everyone.');
      if (!confirm) {
        return;
      }
    }
    this.props.client.mutate({
      mutation: MODERATE_GIF,
      variables: {
        accept,
        gifId: this.props.gif._id,
      },
    }).then(({ data }) => {
      if (data || data.savPendingPremiumGifs) {
        this.setState({ display: false });
        if (accept) {
          this.props.onChange(this.props.gif);
        }
      }
    }).catch((err) => {
      console.log('catch', err);
      if (err.message.includes('401')) {
        alert('You are not allowed to do this.');
      }
    });
  }

  editRank() {
    if (this.props.gif.rank === this.state.rank) {
      return;
    }
    this.props.client.mutate({
      mutation: SET_GIF_RANK,
      variables: {
        gifId: this.props.gif._id,
        rank: this.state.rank,
      },
    }).catch((err) => {
      console.log('catch', err);
      if (err.message.includes('401')) {
        alert('You are not allowed to do this.');
      }
    });
  }

  editDesignerRank() {
    if (this.props.gif.designerRank === this.state.designerRank) {
      return;
    }
    this.props.client.mutate({
      mutation: SET_GIF_DESIGNER_RANK,
      variables: {
        gifId: this.props.gif._id,
        designerRank: this.state.designerRank,
      },
    }).catch((err) => {
      console.log('catch', err);
      if (err.message.includes('401')) {
        alert('You are not allowed to do this.');
      }
    });
  }

  editTags(tags) {
    this.props.client.mutate({
      mutation: SET_GIF_TAGS,
      variables: {
        gifId: this.props.gif._id,
        tags: tags.map((tag) => tag._id),
      },
    }).catch((err) => {
      console.log('catch', err);
      if (err.message.includes('401')) {
        alert('You are not allowed to do this.');
      }
    });
  }

  editAutoReleaseDate() {
    if (!this.state.date || this.state.date.getTime() < new Date()) {
      return;
    }
    const confirmed = confirm( // eslint-disable-line
      `Release automatiquement le sticker le ${moment(this.state.date).format('DD/MM/YYYY')}`
    );
    if (confirmed) {
      this.props.client.mutate({
        mutation: SET_GIF_AUTO_RELEASE_DATE,
        variables: {
          gifId: this.props.gif._id,
          date: this.state.date,
        },
      }).catch((err) => {
        console.log('catch', err);
        if (err.message.includes('401')) {
          alert('You are not allowed to do this.');
        }
      });
    }
  }

  render() {
    if (!this.state.display) {
      return '';
    }
    const { classes } = this.props;
    return (
      <div className="gif">
        <Row>
          <h5>{this.props.gif.name}</h5>
        </Row>
        <Row>
          <img
            className="pixelated"
            src={this.props.gif.base64}
            alt="gif"
            style={{ height: 64, width: 128 }}
          />
          {
            this.props.gif.base64Outlined && (
              <img
                style={{ backgroundColor: '#8A64FF', height: 64, width: 128 }}
                src={this.props.gif.base64Outlined}
                alt="gif"
              />
            )
          }
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          {
            !this.props.hideButtons && (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p className="release-label">Release le</p>
                <DatePicker
                  calendarIcon={null}
                  className="date-picker"
                  clearIcon={null}
                  locale="fr"
                  value={this.state.date}
                  onChange={date => this.setState({ date })}
                />
                <Button
                  onClick={this.editAutoReleaseDate}
                  color="info"
                  className="gifButton"
                  style={{ height: 38, marginLeft: 12 }}
                >
                  OK
                </Button>
              </div>
            )
          }
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <p className="release-label">Rank</p>
            <input
              onBlur={this.editRank}
              onChange={({ target: { value: rank } }) => this.setState({ rank: +rank })}
              style={{ fontSize: 20, height: 38, width: 60, marginTop: 12, borderRadius: 5 }}
              type="number"
              value={this.state.rank}
            />
            <p className="release-label">Designer Rank</p>
            <input
              onBlur={this.editDesignerRank}
              onChange={({ target: { value: designerRank } }) => this.setState({ designerRank: +designerRank })}
              style={{ fontSize: 20, height: 38, width: 60, marginTop: 12, borderRadius: 5 }}
              type="number"
              value={this.state.designerRank}
            />
          </div>
          <div className={classes.root} style={{ marginLeft: '1rem' }}>
            <Autocomplete
              value={this.state.tags}
              onChange={(event, value) => {
                console.log('onchange : ', value);
                this.setState({ tags: value });
                this.editTags(value);
              }}
              multiple
              options={this.props.tags}
              getOptionLabel={(option) => option.titleEn}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Tags"
                  placeholder="New tag"
                />
              )}
            />
          </div>
        </Row>
        <Row className={this.props.hideButtons ? 'd-none' : ''}>
          <Button
            onClick={() => this.moderateGif(false)}
            className="gifButton"
            color="danger"
          >
            Refuser
          </Button>
          <Button
            onClick={() => this.moderateGif(true)}
            className="gifButton"
            color="success"
          >
            Accepter
          </Button>
        </Row>
        <hr/>
      </div>
    );
  }
}

export default withStyles(styles)(Gif);



// WEBPACK FOOTER //
// ./src/components/premium_moderator/gif.js